/**
 * @param {import('firebase/auth').User | null | undefined} user
 * @returns {boolean}
 */
export function hasPasswordProvider(user) {
  return Boolean(user?.providerData?.some((p) => p.providerId === 'password'))
}

/**
 * Human-readable labels for linked sign-in providers.
 * @param {import('firebase/auth').User | null | undefined} user
 * @returns {string[]}
 */
export function getProviderLabels(user) {
  const labels = {
    password: 'Email/password',
    'google.com': 'Google',
    'facebook.com': 'Facebook',
  }

  const ids = user?.providerData?.map((p) => p.providerId) ?? []
  return ids.map((id) => labels[id] || id)
}
